import script from "./BusinessCollectionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessCollectionPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__